import axios from 'axios'
axios.defaults.withCredentials = true

// let base = 'http://cuicanback.cuican520.com/crm' //  测试地址
// let base = 'http://master.cuican520.com/background' //  online
// let base = 'http://58.37.57.242:9898/crm' //  gggg
// let base = 'http://192.168.1.125:9090/crm' // gu本地
// let base = 'http://crm.cuican520.cn/crm'//正式服 
// let base = 'http://47.100.242.86/crm' //  博速
let base = 'http://139.196.94.131:8100/crm' //  琅粤
let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
// export const queryProduct = params => { return axios.get(`${base}/prodtype/queryProduct`, { params: params }).catch( error => {      console.log(error) }) }
//  登录
export const requestLogin = params => {
  return axios.post(`${base}/login/login`, params, config).then(res => res.data).catch(error => {

    console.log(error)
  })
}
//  修改密码
export const loginupdatepwd = params => {
  return axios.post(`${base}/login/updatepwd`, params, config).then(res => res.data).catch(error => {

    console.log(error)
  })
}
//  角色查询
export const queryrole = params => {
  return axios.post(`${base}/role/queryrole`, params).then(res => res.data).catch(error => {

    console.log(error)
  })
}
//  新增角色
export const addRole = params => {
  return axios.post(`${base}/role/addRole`, params).then(res => res.data).catch(error => {

    console.log(error)
  })
}
//  账户信息查询
export const queryall = params => {
  return axios.post(`${base}/account/queryall`, params).then(res => res.data).catch(error => {

    console.log(error)
  })
}
//  新增账户
export const addAccountUser = params => {
  return axios.post(`${base}/account/addAccountUser`, params).then(res => res.data).catch(error => {

    console.log(error)
  })
}
//  根据账户id修改密码
export const updateAccountPwd = params => {
  return axios.post(`${base}/account/updateAccountPwd`, params).then(res => res.data).catch(error => {

    console.log(error)
  })
}
//  账号禁用
export const updateAccountStatus = params => {
  return axios.post(`${base}/account/updateAccountStatus`, params).then(res => res.data).catch(error => {

    console.log(error)
  })
}
//  查询公司
// export const findAll = params => { return axios.post(`${base}/campany/findAll`, params).then(res => res.data).catch( error => {      console.log(error) }) }
export const findAll = params => {
  return axios.get(`${base}/company/findAll`, { params: params }).catch(error => {
    console.log(error)
  })
}
//  添加公司
export const companyadd = params => {
  return axios.post(`${base}/company/add`, params, config).then(res => res.data).catch(error => {

    console.log(error)
  })
}
//  修改公司信息
export const companyupdate = params => {
  return axios.post(`${base}/company/update`, params).then(res => res.data).catch(error => {

    console.log(error)
  })
}
//  删除公司信息
export const companydelete = params => { return axios.post(`${base}/company/delete`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  根据公司id查询联系人信息
export const queryByCompanyId = params => { return axios.get(`${base}/contact/queryByCompanyId`, { params: params }).catch(error => { console.log(error) }) }
//  查询所有联系人
export const contactfindAll = params => { return axios.get(`${base}/contact/findAll`, { params: params }).catch(error => { console.log(error) }) }
//  根据id查询联系人
export const contactquery = params => { return axios.get(`${base}/contact/query`, { params: params }).catch(error => { console.log(error) }) }
//  添加联系人
export const contactadd = params => { return axios.post(`${base}/contact/add`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  修改联系人信息
export const contactupdate = params => { return axios.post(`${base}/contact/update`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  删除联系人信息
export const contactdelete = params => { return axios.post(`${base}/contact/delete`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  查询所有公司类型
export const companytypefindAll = params => { return axios.get(`${base}/company/type/findAll`, { params: params }).catch(error => { console.log(error) }) }
//  根据id查询公司
export const companyquery = params => { return axios.get(`${base}/company/queryById`, { params: params }).catch(error => { console.log(error) }) }
//  查询职位
export const positionfindAll = params => { return axios.get(`${base}/position/findAll`, { params: params }).catch(error => { console.log(error) }) }
//  查询所有商品
export const goodsfindAll = params => { return axios.get(`${base}/goods/findAll`, { params: params }).catch(error => { console.log(error) }) }
//  查询商品详情
export const goodsqueryById = params => { return axios.get(`${base}/goods/queryById`, { params: params }).catch(error => { console.log(error) }) }
//  添加商品
export const goodsadd = params => { return axios.post(`${base}/goods/add`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  更新商品
export const goodsupdateById = params => { return axios.post(`${base}/goods/updateById`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  删除商品
export const goodsdelete = params => { return axios.post(`${base}/goods/delete`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  父子分类列表
export const goodsTypefindAll = params => { return axios.get(`${base}/goodsType/findAll`, { params: params }).catch(error => { console.log(error) }) }
//  分类查询
export const goodsTypegetByParentId = params => { return axios.get(`${base}/goodsType/getByParentId`, { params: params }).catch(error => { console.log(error) }) }
//  添加分类
export const goodsTypeadd = params => { return axios.post(`${base}/goodsType/add`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  修改分类
export const goodsTypeupdateById = params => { return axios.post(`${base}/goodsType/updateById`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  删除分类
export const goodsTypedelete = params => { return axios.post(`${base}/goodsType/delete`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  七牛上传
export const qiniuupload = params => { return axios.post(`${base}/qiniu/upload`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  船务列表信息
export const shipfindAll = params => { return axios.get(`${base}/ship/findAll`, { params: params }).catch(error => { console.log(error) }) }
//  添加船务信息
export const shipadd = params => { return axios.post(`${base}/ship/add`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  修改船务信息
export const shipupdateById = params => { return axios.post(`${base}/ship/updateById`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  删除船务信息
export const shipdelete = params => { return axios.post(`${base}/ship/delete`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  查看船务详情
export const shipqueryById = params => { return axios.get(`${base}/ship/queryById`, { params: params }).catch(error => { console.log(error) }) }
//  库位查询
export const stocklocationfindAll = params => { return axios.get(`${base}/stock/location/findAll`, { params: params }).catch(error => { console.log(error) }) }
//  新增库位
export const stocklocationadd = params => { return axios.post(`${base}/stock/location/add`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  修改库位状态
export const stocklocationupdateStatus = params => { return axios.post(`${base}/stock/location/updateStatus`, params).then(res => res.data).catch(error => { console.log(error) }) }
// 船务商品入库
export const stockadd = params => { return axios.post(`${base}/stock/add`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  库存查询列表
export const stockquerystock = params => { return axios.post(`${base}/stock/querystock`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  根据商品id查询余量
export const stockgoods = params => { return axios.post(`${base}/stock/goods`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  库存详情
export const stockquerydetails = params => { return axios.post(`${base}/stock/querydetails`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  修改库存信息
export const stockupdatestock = params => { return axios.post(`${base}/stock/updatestock`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  模块查询
export const modulequeryModule = params => { return axios.post(`${base}/module/queryModule`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  根据模块id查询相关权限
export const modulequeryModuleIdPermission = params => { return axios.post(`${base}/module/queryModuleIdPermission`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  角色查询权限
export const rolequeryPermissionRoldId = params => { return axios.post(`${base}/role/queryPermissionRoldId`, params, config).then(res => res.data).catch(error => { console.log(error) }) }
//  删除或添加角色权限
export const rolecancelOrAddRolePermission = params => { return axios.post(`${base}/role/cancelOrAddRolePermission`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  删除角色权限
export const rolecancelRolePermission = params => { return axios.post(`${base}/role/cancelRolePermission`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  七牛私有文件下载
export const qiniugetDown = params => { return axios.post(`${base}/qiniu/getDown`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  地址查询
export const areagetByParentId = params => { return axios.get(`${base}/area/getByParentId`, { params: params }).catch(error => { console.log(error) }) }
//  地址分类列表
export const addressTypefindAll = params => { return axios.get(`${base}/addressType/findAll`, { params: params }).catch(error => { console.log(error) }) }
//  销售订单列表
export const orderqueryList = params => { return axios.post(`${base}/order/queryList`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  新增销售订单
export const orderaddOrder = params => { return axios.post(`${base}/order/addOrder`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  货币列表
export const crmcurrency = params => {
  return axios.get(`${base}/currency`, { params: params }).catch(error => {

    console.log(error)
  })
}
//  采购订单列表
export const purchasefindAll = params => {
  return axios.get(`${base}/purchase/findAll`, { params: params }).catch(error => {

    console.log(error)
  })
}
//  新增采购订单
export const purchaseadd = params => { return axios.post(`${base}/purchase/add`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  修改采购订单
export const purchaseupdateById = params => { return axios.post(`${base}/purchase/updateById`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  采购订单详情
export const purchasegetById = params => { return axios.get(`${base}/purchase/getById`, { params: params }).catch(error => { console.log(error) }) }
//  订单审核
export const orderreviewOrder = params => { return axios.post(`${base}/order/reviewOrder`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  更新订单
export const orderupdateOrder = params => { return axios.post(`${base}/order/updateOrder`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  删除订单
export const orderdeleteOrder = params => { return axios.post(`${base}/order/deleteOrder`, params).then(res => res.data).catch(error => { console.log(error) }) }
// 规格列表
export const goodsSpec = params => { return axios.get(`${base}/goodsSpec`, { params: params }).catch(error => { console.log(error) }) }
// 销售订单详情
export const orderqueryOrderDetails = params => { return axios.post(`${base}/order/queryOrderDetails`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  根据公司和地址类型查询地址
export const addressfindByCompanyId = params => { return axios.get(`${base}/address/findByCompanyId`, { params: params }).catch(error => { console.log(error) }) }
//  补货列表
export const damagedquerydamaged = params => { return axios.post(`${base}/damaged/querydamaged`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  不补货列表
export const damagedqueryBuBuHuoList = params => { return axios.post(`${base}/damaged/queryBuBuHuoList`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  需要补货的销售订单关联批号
export const orderqueryBatchNumberById = params => { return axios.post(`${base}/order/queryBatchNumberById`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  发货
export const orderconsignment = params => { return axios.post(`${base}/order/consignment`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  销售订单确认收货
export const orderconfirmReceipt = params => { return axios.post(`${base}/order/confirmReceipt`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  待补全处理列表
export const damagedpendingdamagedList = params => { return axios.post(`${base}/damaged/pendingdamagedList`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  补货理由以及数量
export const damagedreplenishdamaged = params => { return axios.post(`${base}/damaged/replenishdamaged`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  补发货信息
export const damagedshipments = params => { return axios.post(`${base}/damaged/shipments`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  补货详情
export const damagedqueryDamagedDetails = params => { return axios.post(`${base}/damaged/queryDamagedDetails`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  补货确认收货
export const damagednotarizeCargo = params => { return axios.post(`${base}/damaged/notarizeCargo`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  开票列表
export const orderqueryByInvoiceLaterList = params => { return axios.post(`${base}/order/queryByInvoiceLaterList`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  开票列表
export const orderqueryInvoiceAndReceipt = params => { return axios.post(`${base}/order/queryInvoiceAndReceipt`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  开票类型 1.开票类型，2.税率
export const dictionariesqueryDictionaryData = params => { return axios.post(`${base}/dictionaries/queryDictionaryData`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  收款
export const orderreceiptMoney = params => { return axios.post(`${base}/order/receiptMoney`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  开票
export const ordermakeOutInvoice = params => { return axios.post(`${base}/order/makeOutInvoice`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  开票修改
export const orderupdateInvoiceAndReceipt = params => { return axios.post(`${base}/order/updateInvoiceAndReceipt`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  破包统计
export const replenishlist = params => { return axios.get(`${base}/replenish/list`, { params: params }).catch(error => { console.log(error) }) }
//  添加统计
export const replenishadd = params => { return axios.post(`${base}/replenish/add`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  待补货订单
export const damagedgetBrokeOrder = params => { return axios.get(`${base}/damaged/getBrokeOrder`, { params: params }).catch(error => { console.log(error) }) }
//  详情
export const replenishdetail = params => { return axios.get(`${base}/replenish/detail`, { params: params }).catch(error => { console.log(error) }) }
//  搜索批号
export const batchgetContact = params => { return axios.get(`${base}/batch/getContact`, { params: params }).catch(error => { console.log(error) }) }
//  月结算记录列表
export const settlemonthlist = params => { return axios.get(`${base}/settle/month/list`, { params: params }).catch(error => { console.log(error) }) }
//  杂费基础信息列表
export const settlementlist = params => { return axios.get(`${base}/settlement/list`, { params: params }).catch(error => { console.log(error) }) }
//  新增
export const settlementadd = params => { return axios.post(`${base}/settlement/add`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  删除
export const settlementdelete = params => { return axios.post(`${base}/settlement/delete`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  杂费列表
export const settlePriceorderManagerList = params => { return axios.get(`${base}/settlePrice/orderManagerList`, { params: params }).catch(error => { console.log(error) }) }
//  公共结算信息
export const settlementgetLast = params => { return axios.get(`${base}/settlement/getLast`, { params: params }).catch(error => { console.log(error) }) }
//  结算
export const settlePricedoSettle = params => { return axios.post(`${base}/settlePrice/doSettle`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  编辑详情
export const settlePricegetSettle = params => { return axios.get(`${base}/settlePrice/getSettle`, { params: params }).catch(error => { console.log(error) }) }
//  编辑操作
export const settlePriceupdateSettle = params => { return axios.post(`${base}/settlePrice/updateSettle`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  开票详情
export const settlemonthpreInvoice = params => { return axios.get(`${base}/settle/month/preInvoice`, { params: params }).catch(error => { console.log(error) }) }
//  所有的小查看
export const settlePricegetDetail = params => { return axios.get(`${base}/settlePrice/getDetail`, { params: params }).catch(error => { console.log(error) }) }
//  开票
export const settlemonthdoInvoice = params => { return axios.post(`${base}/settle/month/doInvoice`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  收款详情
export const settlemonthgetInvoiceDetail = params => { return axios.get(`${base}/settle/month/getInvoiceDetail`, { params: params }).catch(error => { console.log(error) }) }
//  收款
export const settlemonthreceive = params => { return axios.post(`${base}/settle/month/receive`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  付汇
export const purchasepayment = params => { return axios.post(`${base}/purchase/payment`, params).then(res => res.data).catch(error => { console.log(error) }) }
//  查询付汇
export const purchasequerypayment = params => { return axios.get(`${base}/purchase/querypayment`, { params: params }).catch(error => { console.log(error) }) }
//  汇率列表
export const profitlist = params => { return axios.get(`${base}/profit/list`, { params: params }).catch(error => { console.log(error) }) }
//  汇率详情
export const profitdetail = params => { return axios.get(`${base}/profit/detail`, { params: params }).catch(error => { console.log(error) }) }
//  半年汇率基础数据调整
export const profitupdateBasic = params => { return axios.post(`${base}/profit/updateBasic`, params).then(res => res.data).catch(error => { console.log(error) }) }

export const testgetexcel = (params, responseType) => { return axios.post(`${base}/test/getexcel`, params, responseType).then(res => res.data).catch(error => { console.log(error) }) }

//  总订单列表
export const ordertotalOrderList = (params, responseType) => { return axios.post(`${base}/order/totalOrderList`, params, responseType).then(res => res.data).catch(error => { console.log(error) }) }

export const orderaddTotalOrder = (params, responseType) => { return axios.post(`${base}/order/addTotalOrder`, params, responseType).then(res => res.data).catch(error => { console.log(error) }) }
//  补充不补货数据
export const damagedaddUpadteBuBuHuo = (params, responseType) => { return axios.post(`${base}/damaged/addUpadteBuBuHuo`, params, responseType).then(res => res.data).catch(error => { console.log(error) }) }
//  下载
export const excelgetexcel = (params, responseType) => { return axios.post(`${base}/excel/getexcel`, params, responseType).then(res => res.data).catch(error => { console.log(error) }) }

export const excelgetExcelExchangeRate = (params, responseType) => { return axios.post(`${base}/excel/getExcelExchangeRate`, params, responseType).then(res => res.data).catch(error => { console.log(error) }) }
//
